<template>
<div class="h-screen mainpage flex justify-center items-center font-snig text-base">
    <router-view/>
</div>
</template>

<script>
export default {
    name: 'AuthApp',
}
</script>
